import { useEffect, useRef, useState } from "react";
import { SystemContentModel } from "../models/SystemContentModel";

interface ViewTermsContentCompProps {
    show: boolean;
    termsContent: SystemContentModel;
    onClose: () => void;
    bodyScrollRef: React.RefObject<HTMLDivElement | null>;
    onBodyScroll: () => void;
    canAgree: boolean;
    onAgree: () => void;
}

const ViewTermsContentComp: React.FC<ViewTermsContentCompProps> = ({
    show,
    termsContent,
    onClose,
    bodyScrollRef,
    onBodyScroll,
    canAgree,
    onAgree,
}) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const bsModalRef = useRef<any>(null);

    const [showAgreeWarning, setShowAgreeWarning] = useState(false);

    useEffect(() => {
        if (!modalRef.current)
            return;

        const bootstrap = (window as any).bootstrap;
        bsModalRef.current = bootstrap?.Modal?.getInstance(modalRef.current) ?? new bootstrap.Modal(modalRef.current);

        const handleHidden = () => onClose();
        modalRef.current.addEventListener("hidden.bs.modal", handleHidden);

        return () => {
            modalRef.current?.removeEventListener("hidden.bs.modal", handleHidden);
        };
    }, [onClose]);

    useEffect(() => {
        if (!bsModalRef.current) return;

        if (show) {
            bsModalRef.current.show();
            setShowAgreeWarning(false);
        }
        else {
            bsModalRef.current.hide();
        }
    }, [show]);

    useEffect(() => {
        if (canAgree)
            setShowAgreeWarning(false);

    }, [canAgree]);

    const requestClose = () => {
        bsModalRef.current?.hide();
    };

    const handleAgreeClick = () => {
        if (!canAgree) {
            setShowAgreeWarning(true);
            return;
        }

        onAgree();
        bsModalRef.current?.hide();

    };

    const handleBodyScroll: React.UIEventHandler<HTMLDivElement> = () => {
        onBodyScroll();
    };

    return (
        <div
            className="modal fade"
            tabIndex={-1}
            ref={modalRef}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content rounded-0">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {termsContent.contentName} v{termsContent.contentVersion}
                        </h5>
                        <button type="button" className="btn-close" onClick={requestClose} />
                    </div>

                    <div
                        className="modal-body border-bottom"
                        ref={bodyScrollRef}
                        onScroll={handleBodyScroll}
                        style={{ maxHeight: "60vh", overflowY: "auto" }}
                    >
                        <div
                            style={{ whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: termsContent.contentText }}
                        />
                    </div>
                    {showAgreeWarning && (
                        <div className="px-3 pb-2 mt-3 ">
                            <small className="text-danger">
                                Please review the full terms before continuing.
                            </small>
                        </div>
                    )}
                    <div className="modal-footer d-flex gap-2">
                        <button className="btn btn-outline-dark rounded-0" onClick={requestClose}>
                            Close
                        </button>

                        <button
                            className="btn btn-dark rounded-0 ms-auto"
                            onClick={handleAgreeClick}
                            title={!canAgree ? "Please review the terms to continue" : undefined}
                        >
                            I Agree
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewTermsContentComp;
